import config from 'js/app/config';
import { tupleToStringKey } from 'js/lib/stringKeyTuple';
import { useLocation, useParams } from 'js/lib/useRouter';

import { useDegreeDescriptionPageData } from 'bundles/degree-description/contexts/DegreeDescriptionPageContext';
import { EOI_SURVEY_VARIANTS } from 'bundles/expression-of-interest/constants';
import { getEoiContext, getEoiCurrentUrl } from 'bundles/expression-of-interest/utils/util';
import { ProductTypes } from 'bundles/university-program-qualification/utils/constants';

const useDegreeEoiSurveyProps = () => {
  const { id } = useDegreeDescriptionPageData();
  const { slug } = useParams();
  const location = useLocation();

  const currentUrl = getEoiCurrentUrl({
    baseUrl: config.url.base,
    slug,
    pathname: location.pathname,
    search: location.search ?? '',
  });

  return {
    productId: tupleToStringKey([ProductTypes.DEGREE, id]),
    surveyVariant: EOI_SURVEY_VARIANTS.degreeMultistep,
    eoiContext: getEoiContext(currentUrl),
  };
};

export default useDegreeEoiSurveyProps;
